const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

function trimTrailingSlash(url: string) {
  return url.replace(/\/+$/, '');
}

function getCurrentOrigin() {
  return globalThis.location?.origin;
}

function isLocalSameHost(target: URL, current: URL) {
  return (
    LOCAL_HOSTNAMES.has(target.hostname) &&
    target.hostname === current.hostname &&
    target.port === current.port
  );
}

/**
 * Resolve HTTP API base URLs for cloud storage.
 *
 * Dev users can carry stale server metadata such as https://localhost:8080
 * while the actual app is served from http://localhost:8080. Browser uploads
 * then fail before reaching the backend with ERR_SSL_PROTOCOL_ERROR. For that
 * exact same-localhost case, the current page origin is authoritative.
 */
export function resolveCloudHttpBaseUrl(
  serverBaseUrl: string,
  currentOrigin = getCurrentOrigin()
) {
  const target = new URL(serverBaseUrl);

  if (currentOrigin) {
    const current = new URL(currentOrigin);
    if (
      current.protocol === 'http:' &&
      target.protocol === 'https:' &&
      isLocalSameHost(target, current)
    ) {
      return trimTrailingSlash(current.origin);
    }
  }

  return trimTrailingSlash(target.toString());
}

export function resolveCloudHttpEndpoint(
  serverBaseUrl: string,
  path: string,
  currentOrigin = getCurrentOrigin()
) {
  const baseUrl = resolveCloudHttpBaseUrl(serverBaseUrl, currentOrigin);
  return new URL(path, `${baseUrl}/`).toString();
}
